import React, { useEffect, useState } from "react";
import { Card, Col, Row, Tooltip } from "antd";
import * as Utilities from '../../Utilities';
import ENVIRONMENT from '../../../../environments';

import axios from "axios";

const ActiveModelsKeys = {
    review: "in-review",
    progress: "in-progress",
    drafts: "drafts"
}

const ActiveModelCard = (props) => {
    let entity = props.model;
    let type = props.type;

    const getStatusString = (status) => {
        if (status == "1" || status == "11") {
            return "Incomplete";
        } else if (["2", "3", "6", "7", "8", "11"].includes(status)) {
            return "ALL3D is creating";
        } else if (status == "4") {
            return "Needs Review";
        } else {
            return "ALL3D is creating";
        }
    };

    const getThumbnail = (ele) => {
        let uri = '';
        if (ele.type == 'Product') {
            uri = 'product_assets/thumbnail/'
        } else if (ele.type == 'Space') {
            uri = `room_assets/thumbnail/${ele.id}/`
        }
        if (ele.thumbnail != "") {
            return ENVIRONMENT.getBaseURL(ele.platform) + uri + ele.thumbnail;
        }
    };

    const getIconString = (status) => {
        if (status == "1") {
            return '/img/exclamation-red.svg';
        } else if (["2", "3", "6", "7", "8", "11"].includes(status)) {
            return '/img/carbon_time.svg';
        } else if (status == "4") {
            return '/img/exclamation-red.svg';
        } else {
            return '/img/carbon_time.svg';
        }
    };

    const onClickActiveModels = (id, type, entity) => {
        if (type == 'Product') {
            if (props.modelsTabKey == ActiveModelsKeys.drafts) {
                if (entity.uploaded_model && entity.model_status == "-6") {
                    window.location.href = `/product_page/${id}`
                } else if (entity.uploaded_model) {
                    window.location.href = `/upload-product-model/${id}?uploaded-model=true`
                } else if (entity.designed_product) {
                    window.location.href = `/add-new-product/${id}`
                } else {
                    window.location.href = `/create-existing-physical-product/${id}`
                }
            } else {
                if (entity.model_status === "4") {
                    window.location.href = `/product-qa/${id}`
                } else {
                    window.location.href = `/product_page/${id}`
                }
                
            }
        } else if (type == 'Space') {
            if (props.modelsTabKey == ActiveModelsKeys.drafts) {
                window.location.href = `/add-new-room?step=0&room_id=${id}`
            } else {
                window.location.href = `/rooms/${id}`
            }
        } else if (type == 'Material') {
            if (props.modelsTabKey == ActiveModelsKeys.drafts) {
                if (entity.is_scanned) {
                    window.location.href = `/upload-scanned-material/${id}`;
                } else {
                    window.location.href = `/create-new-material/${id}`;
                }
            } else {
                props.setMaterialModal(true);
                props.setSelectedMaterial('');
                let payload = {
                    material_id: id
                };
                axios.post(ENVIRONMENT.MATERIAL_GET, payload)
                .then(res => {
                    let material_data = JSON.parse(res.data.body);
                    props.setSelectedMaterial(material_data);
                });
            }
        }
    };

    return (
        <a onClick={() => { onClickActiveModels(entity.id, entity.type, entity) }}>
            <Card>
                <Row>
                    {type == ActiveModelsKeys.review ? 
                        <Col span={24}>
                            <img
                            style={{ objectFit: "contain", width: "100%", height: 250, zIndex:1 }}
                            src={getThumbnail(entity)}/>
                        </Col> :
                        <Col span={24} style={{ height: 250, backgroundColor: '#fafafa' }} className="justify-in-center">
                            <img
                            style={{ objectFit: "contain", width: "40%", height: "40%", zIndex:1 }}
                            src={require(`../../../../assets/images/${entity.type == "Product" ? "product" : entity.type == "Space" ? "space" : "material"}_incomplete.svg`)}
                            />
                        </Col>
                    }
                </Row>
                <Row style={{ marginLeft: 15, marginRight: 15, marginTop: 15 }}>
                    <Col span={12} className="justify-in-start">
                        <span className={`model-type-btn ${entity.type == "Product" ? "blue" : entity.type == "Space" ? "yellow" : "red"}`}>{entity.type}</span>
                    </Col>
                    <Col span={12} className="justify-in-end" >
                        <Tooltip title={<span className='manrope f-12 white'>{Utilities.timestampToTimeSince(entity.last_modified, 'tooltip')}</span>}>                                                  
                            <span className="manrope f-12 grey-77 w-500 time-clock-bg"  style={{marginLeft: 4}}>
                                <img src='/img/carbon_time.svg' style={{marginRight: 2}}/>{Utilities.timestampToTimeSince(entity.last_modified)}
                            </span>
                        </Tooltip>
                    </Col>
                    <Col span={24} style={{ marginTop: 10 }}>
                        <Tooltip title={entity.name}>
                            <p className="info-text size-14 black limit-line w-280">{entity.name}</p>
                        </Tooltip>
                    </Col>
                    {type == ActiveModelsKeys.review ? 
                    <Col span={24}>
                        <Tooltip title={entity.category}>
                            <div className="justify-in-start" style={{ marginRight: 12, marginBottom: 4, textAlign: "left" }}>
                                <span className="info-text size-14 light-gray" style={{ marginRight: 10 }}>Category</span>
                                <span className="info-text size-14 black">{entity.category}</span>
                            </div>
                        </Tooltip>
                    </Col>
                    : ""}
                </Row>
                <Row style={{ marginLeft: 15, marginRight: 15, marginTop: 5, marginBottom: 15 }}>
                    <Col span={3} className="justify-in-start">
                        <img src={getIconString(entity.model_status)} style={{ width: 24, height: 24 }}/>
                    </Col>
                    <Col span={21} className="justify-in-start">
                        <span className="info-text size-14 black w-600">{getStatusString(entity.model_status)}</span>
                    </Col>
                </Row>
            </Card>
        </a>
    );
};

export default ActiveModelCard;